// extracted by mini-css-extract-plugin
var _1 = "styles-module__download___HOkn1";
var _2 = "styles-module__link___v0vdg";
var _3 = "styles-module__phone___rK0By";
var _4 = "styles-module__sendALink___D66mC";
export { _1 as "download", _2 as "link", _3 as "phone", _4 as "sendALink" }
